<template>
<div>

  <Row :gutter="10">
    <Col span="4"><search-city placeholder="Order City" v-model="clientCity"/></Col>
    <Col span="4"><search-city placeholder="Pickup City" v-model="pickupCity"/></Col>
    <Col span="4"><search-city placeholder="Drop City" v-model="dropCity"/></Col>

    <Button v-if="isAdmin" @click="exportCreateClientInvoicesCSV" :loading="exportLoading" style="float: right;" type="success">Export CSV</Button>
    <DatePicker v-model="filterDate" type="daterange" :options="dateOptions" placeholder="Select date" :clearable="false"
                format="dd/MM/yyyy" class="filterInput" style="width: 260px; float: right;margin-right: 10px"/>
  </Row>

  <hot-table :settings="hotSettings" ref="hotTableComponent" style="margin: 20px 0 0 0">
    <hot-column v-for="(colset, index) in computedColumns" :settings="colset" :key="index"/>
  </hot-table>

  <confirm-cell-update :dialog.sync="cellUpdateDialog" :cellJSON.sync="cellJSON" @updateCell="updateCell"/>
  <manage-order :orderId="orderId" ref="manage-order-page" :viewPath="viewPath"/>
  <charges-form :dialog.sync="chargesFormDialog" :clientInvoiceId.sync="clientInvoiceId" :pointTypeId="pointTypeId"/>
  <pending-approval-action :dialog.sync="pendingApprovalActionDialog" :clientInvoiceId.sync="clientInvoiceId"/>
  <pending-cancel-action :dialog.sync="pendingCancelActionDialog" :clientInvoiceId.sync="clientInvoiceId"/>
</div>
</template>

<script>
import { HotTable, HotColumn } from '@handsontable/vue';
import {Constants} from "../../../Constants/Constant";
import moment from 'moment';
import {dateOptions, roughtOfOrder} from "../../ExcelFormattedOrders/Settings";
import ManageOrder from "../../Manage Order/ManageOrder";
import {SUBSCRIBE_CLIENT_INVOICES_BY_ORDER_DATE} from "../../../graphql/subscription/clientInvoices";
import {
  billingFreightRenderer, createClientActionRenderer, dropCityChargesRenderer, orderCityChargesRenderer,
  orderDetailsRenderer, orderNumberRenderer, pickupCityChargesRenderer, statusRenderer, totalAmountRenderer
} from "../RendererFunctions";
import {hotSettingsClientInvoices, CellSettings, exportClientInvoicesCSV, totalChargesAmount} from "../Settings";
import ChargesForm from "../ChargesForm";
import ConfirmCellUpdate from "../../Common/ConfirmCellUpdate";
import {generate_UPDATE_ORDER_DATA} from "../../../graphql/mutations/orders";
import Vue from 'vue';
import PendingApprovalAction from "../Actions/PendingApprovalAction";
import PendingCancelAction from "../Actions/PendingCancelAction";
import SearchCity from "../../Common/SearchCity";
export default {
  name: "CreateInvoiceWhole",
  props:['globalSearch'],
  components: {
    SearchCity,
    PendingCancelAction, PendingApprovalAction, ConfirmCellUpdate, ChargesForm, ManageOrder, HotTable, HotColumn},
  provide() {
    return {
      getManageOrderDrawer: () => this.manageOrderDrawer,
      setManageOrderDrawer: (data) => { this.manageOrderDrawer = data },
      getOrder: () => this.order,
      closeAssignVehicleDialog: (data) => { },
    }
  },
  apollo: {
    $subscribe: {
      clientInvoices: {
        query: SUBSCRIBE_CLIENT_INVOICES_BY_ORDER_DATE,
        fetchPolicy: 'network-only',
        variables() { return {
          startDate: moment(this.filterDate[0], 'DD/MM/YYYY').format('YYYY-MM-DDT00:00:00+05:30'),
          endDate: moment(this.filterDate[1], 'DD/MM/YYYY').format('YYYY-MM-DDT23:59:59+05:30'),
          status: [Constants.ClientInvoiceStatus.New],
          clientCity: {address: (this.clientCity?[{city: this.clientCity}]:[])},
          pickupCity: {address: (this.pickupCity?[{city: this.pickupCity}]:[])},
          dropCity: {address: (this.dropCity?[{city: this.dropCity}]:[])},
          search: '%' + this.globalSearch + '%',
          lrName: { lrName: this.globalSearch },
        }},
        result ({ data }) { this.clientInvoices = data.clientInvoices; this.prepareSheetData(data.clientInvoices) }
      }
    }
  },
  data() {
    return {
      Constants: Constants,
      moment: moment,
      clientInvoices: [],
      columns: [
        {title: 'Pickup<br> Date', data: 'pickupDate', type: 'date', dateFormat: 'DD MMM \'YY' },
        {title: 'Order No', data: 'orderNumber', renderer: (...args) => orderNumberRenderer(...args, this, 'clientInvoices') },
        {title: 'Order<br> City', data: 'orderCity'},
        {title: 'Client Name', data: 'clientName'},
        {title: 'Route', data: 'route'},
        {title:'Status', data: 'internalStatusId', renderer: statusRenderer, exportKey: 'internalStatus'},
        {title: 'LR No', data: 'lr'},
        {title: 'Truck<br>Number', data: 'truckPlateNumber'},
        {title: 'Weight', data: 'kg', type: 'numeric'},
        {title: 'Order<br> Details', data: 'boxes', exportKey:'orderDetails', renderer: (...args) => orderDetailsRenderer(...args, this, 'clientInvoices')},
        {title: 'Order<br> City<br> Charges', data: 'orderCityCharges', renderer: (...args) => orderCityChargesRenderer(...args, this, 'clientInvoices')},
        {title: 'Pickup<br> City<br> Charges', data: 'pickupCityCharges', renderer: (...args) => pickupCityChargesRenderer(...args, this, 'clientInvoices')},
        {title: 'Drop<br> City<br> Charges', data: 'dropCityCharges', renderer: (...args) => dropCityChargesRenderer(...args, this, 'clientInvoices')},
        {title: 'Special<br> Offered<br> Freight', data: 'splOfferedFreight'},
        {title: 'Billing<br> Freight', data: 'clientInvoices_billingFreight', renderer: (...args) => billingFreightRenderer(...args, this, 'clientInvoices')},
        {title: 'Total<br> Amount', data: 'totalAmount', renderer: (...args) => totalAmountRenderer(...args, this, 'clientInvoices')},
      ],
      hotSettings: hotSettingsClientInvoices([90, 100, 90, 120, 100, 145, 90, 115, 80, 90, 80, 80, 80, 100, 80, 80, 110], this, 'hotTableComponent'),
      dateOptions,
      filterDate: [moment().subtract(7, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
      clientCity: '', pickupCity: '', dropCity: '',
      manageOrderDrawer: false,
      orderId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
      currentOrderStatus: '',
      order: '',
      viewPath: '',
      chargesFormDialog: false,
      clientInvoiceId: null,
      pointTypeId: null,
      cellUpdateDialog: false, cellJSON: {},
      pendingApprovalActionDialog: false,
      pendingCancelActionDialog: false,
      exportLoading: false
    }
  },
  computed: {
    isAdmin: function(){
      return this.$store.state.userObj.role[0].id === Constants.adminRoleId
    },
    computedColumns: function(){
      let actionCol = {title:'Action', data:'action', excludeInExport: true, renderer:(...args) => createClientActionRenderer(...args, this, 'clientInvoices')};
      return this.isAdmin?[...this.columns, actionCol]:[...this.columns]
    }
  },
  methods: {
    prepareSheetData(data) {
      let mainArr = [];
      data.forEach(curnt => {
        curnt.obj = {
          pickupDate: moment(curnt.Order.pickupDate, 'YYYY-MM-DD').format('DD/MM/YYYY'),
          orderNumber: curnt.Order.orderNumber,
          internalStatusId: curnt.Order.internalstatus,
          internalStatus: curnt.Order.internalStatus.name,
          orderCity: curnt.Order.clientobject.address[0].city,
          clientName: curnt.Order.clientobject.name,
          route: roughtOfOrder(curnt.Order),
          lr: curnt.Order.orderDetails.lrObject?.lrName||'',
          truckPlateNumber: curnt.Order.orderDetails.truckOrder?.truck.platNo||'-',
          kg: curnt.Order.materials.kg,
          boxes: curnt.Order.materials.boxes,
          orderCityCharges: curnt.orderCharges.aggregate.sum.amount,
          pickupCityCharges: curnt.pickupCharges.aggregate.sum.amount,
          dropCityCharges: curnt.dropCharges.aggregate.sum.amount,
          splOfferedFreight: curnt.Order.orderDetails.splOfferedFreight||0,
          clientInvoices_billingFreight: curnt.billingFreight,
          totalAmount: totalChargesAmount(curnt),
          action: '',
          orderDetails: curnt.Order.materials.type + ' (' + curnt.Order.materials.boxes + ')'
        };
        mainArr.push(curnt.obj)
      });
      this.hotSettings.data = mainArr;
      this.updateTableSettings();
    },
    updateTableSettings() {
      if(!this.$refs['hotTableComponent']) return;
      let hotInstance = this.$refs['hotTableComponent'].hotInstance;
      let roleId = this.$store.state.userObj.role[0].id;
      let settings = CellSettings[roleId];
      hotInstance.updateSettings({
        cells: function (row, col, prop) {
          let cellProperties = {};
          if(settings && settings[prop]){
            cellProperties.readOnly = settings[prop].isReadOnly
          }
          return cellProperties;
        }
      })
    },
    openChargesForm(pointTypeId, clientInvoiceId){
      this.pointTypeId = pointTypeId;
      this.clientInvoiceId = clientInvoiceId;
      this.chargesFormDialog = true;
    },
    openActionPopup(dialog, clientInvoiceId){
      this.clientInvoiceId = clientInvoiceId;
      this[dialog] = true;
    },
    editOrder(order){
      this.orderId = order.id;
      this.viewPath = order.internalStatus.viewPath;      //Load form based on internalStatus.viewPath
      this.order = order;
      this.currentOrderStatus = order.internalStatus.id;
      this.manageOrderDrawer = true;
    },
    async updateCell({row, prop, newValue}){
      Vue.set(this.cellJSON, 'loading', true);
      let hotInstance = this.$refs['hotTableComponent'].hotInstance;
      let pRow = hotInstance.toPhysicalRow(row);                        //When accessing original array

      let obj = {}, id = '', record = this['clientInvoices'][pRow];

      let [table, key, intermediate] = prop.split('_');                                               //eg. orderDetails_lrName_lrObject

      if(!intermediate) obj[key] = newValue;

      switch(table){
        case 'clientInvoices': id = record.id;
          break
      }
      let response = await this.$apollo.mutate({
        mutation: generate_UPDATE_ORDER_DATA(table),
        variables: {id, obj},
      });
      if(response.data) {
        Vue.set(this.cellJSON, 'loading', false);
        this.$Message.success('Field ' +key+ ' updated successfully!');
        this.cellUpdateDialog = false;
      }
    },
    exportCreateClientInvoicesCSV(){
      this.exportLoading = true;
      let data = this.hotSettings.data;
      let fileName = 'CreateClientInvoices_' + moment().format('DD_MMM_YYYY_HH_mm') + '.csv';
      let dateRange = moment(this.filterDate[0], 'DD/MM/YYYY').format('DD-MM-YYYY') + ' - ' + moment(this.filterDate[1], 'DD/MM/YYYY').format('DD-MM-YYYY');
      let summary = 'Date' +',' + dateRange + '\n' + 'Order City' +',' + (this.clientCity||'-') + '\n' + 'Pickup City' +',' + (this.pickupCity||'-') + '\n' +
        'Drop City' +',' + (this.dropCity||'-') + '\n' + 'Exported On' +',' + ('="'+moment().format('DD-MM-YYYY hh:mm:ss A')+'"')+ '\n\n';
      exportClientInvoicesCSV(this.computedColumns, data, summary, fileName);
      this.exportLoading = false;
    }
  }
}
</script>

<style scoped>
  /deep/ .ivu-date-picker-cells  {
    font-size: 12px !important;
  }
  /deep/ .ivu-picker-panel-sidebar  {
    width:125px !important;
    margin-left:-116px !important;
  }
  /deep/ .handsontable > .ht_master{
    font-size: 14px;
  }
  /deep/ .handsontable > .ht_master > .wtHolder{
    width: unset !important;
    height: unset !important;
  }
  /deep/ .handsontable span.colHeader {
    font-size: 13px;
  }
  /deep/.handsontable td{
    vertical-align: middle !important;
    padding: 0 1px 0 1px !important;
    white-space: unset !important;
    font-size: 13px;
    color: #222;
  }

  /deep/.handsontable th{
    background-color: #d9d9d9;
    color: #222;
    text-align: center;
    font-weight: 600;
    vertical-align: middle !important;
    white-space: nowrap !important;
    padding: 0 0px 0 0px !important;
  }
</style>
<style>
.underline-txt:hover {
  text-decoration: underline;
  cursor: pointer;
}
.charge-amount {
  text-decoration: underline;
  cursor: pointer;
}
.add-link{
  color: blue !important;
}
.action-btn{
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}
.green-txt{
  color: #85b86f !important;
}
.red-txt{
  color: red !important;
}
.include-query{
  color: red !important;
  background: #fce5cd !important;
  font-weight: 600;
}
.no-query{
  color: green !important;
  background: #d8ead3 !important;
  font-weight: 600;
}
.returned-invoice td{
  background: #f5e108 !important;
  color: #202020;
}
</style>
<style src="../../../../node_modules/handsontable/dist/handsontable.full.css"></style>
